import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { speech } from "../audio/speechService";
import { BigButton, Card } from "../design/BigButton";
import { MascotBubble } from "../design/MascotBubble";
import { Volume2 } from "lucide-react";
import { useSettings } from "../contexts/SettingsContext";

export function WordBookScreen() {
  const { profileId } = useParams();
  const navigate = useNavigate();
  const settings = useSettings();
  const [words, setWords] = useState({ items: [], categories: [] });
  const [filter, setFilter] = useState("all");
  const [category, setCategory] = useState(null);

  useEffect(() => { reload(filter, category); /* eslint-disable-next-line */ }, [filter, category]);
  function reload(f, c) {
    const params = {};
    if (f === "favorites") params.favorites = true;
    if (f === "practice") params.practice = true;
    if (f === "recent") params.sort = "recent";
    if (c) params.category = c;
    api.get(`/wordbook/${profileId}`, { params }).then((r) => setWords(r.data));
  }
  async function play(w) {
    await api.post(`/wordbook/${profileId}/replay-word`, { learningObjectId: w.learningObjectId });
    await speech.speak(w.displayName, {
      speed: settings.narrationSpeed,
      prerecordedUrl: w.wordAudioUrl || null,
    });
    await speech.speakLetters(w.spellingSequence || [], {
      speed: settings.narrationSpeed,
      prerecordedUrl: w.spellingAudioUrl || null,
    });
  }
  async function toggleFav(w) {
    await api.post(`/wordbook/${profileId}/favorite`, { learningObjectId: w.learningObjectId, isFavorite: !w.isFavorite });
    reload(filter, category);
  }

  return (
    <div className="wmleye-app child-wordbook" data-testid="child-wordbook">
      <header>
        <BigButton variant="ghost" onClick={() => navigate(`/child/${profileId}/home`)} data-testid="wordbook-back">← Home</BigButton>
        <h1>Word Book</h1>
      </header>
      <div className="wb-filters">
        {["all", "favorites", "recent", "practice"].map((f) => (
          <BigButton key={f} variant={filter === f ? "primary" : "ghost"} onClick={() => setFilter(f)} data-testid={`wb-filter-${f}`}>
            {f}
          </BigButton>
        ))}
      </div>
      {words.categories.length > 0 && (
        <div className="wb-cats">
          <button onClick={() => setCategory(null)} className={!category ? "wb-cat wb-cat--sel" : "wb-cat"} data-testid="wb-cat-all">All</button>
          {words.categories.map((c) => (
            <button key={c} onClick={() => setCategory(c)} className={category === c ? "wb-cat wb-cat--sel" : "wb-cat"} data-testid={`wb-cat-${c}`}>{c}</button>
          ))}
        </div>
      )}
      {words.items.length === 0 ? (
        <Card><MascotBubble text="Play a level to start filling your Word Book!" /></Card>
      ) : (
        <div className="wb-grid">
          {words.items.map((w) => (
            <Card key={w.learningObjectId} data-testid={`wb-card-${w.canonicalName}`}>
              {w.thumbnailUrl && <img src={w.thumbnailUrl} alt="" className="wb-thumb" />}
              <h3 className="wb-name">{w.displayName}</h3>
              <p className="wb-spelling">{(w.spellingSequence || []).join(" ")}</p>
              <div className="wb-actions">
                <BigButton onClick={() => play(w)} data-testid={`wb-play-${w.canonicalName}`}><Volume2 size={18} /> Say it</BigButton>
                <BigButton variant="sun" onClick={() => toggleFav(w)} data-testid={`wb-fav-${w.canonicalName}`}>{w.isFavorite ? "★" : "☆"}</BigButton>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
